import PropTypes from 'prop-types'
import React, { useEffect, useRef } from 'react'

import InformationContainer from '../../components/informationContainer/InformationContainer'
import { useTranslation } from '../../utils/useTranslation'
import { Column, MobileLink, Span, Value } from './common'

const UserDesigner = ({ firstName, lastName, email, phoneNumber }) => {
  const { t } = useTranslation('app.pages.user-settings.designer')
  const el = useRef()
  useEffect(() => {
    if (el && el.current && location.href.includes('#your-designer')) {
      el.current.scrollIntoView({
        behaviour: 'smooth',
        block: 'start',
        inline: 'center',
      })
    }
  }, [el])
  return (
    <>
      <InformationContainer title={t('heading')}>
        <Column ref={el}>
          <Value>
            {firstName} {lastName}
          </Value>
        </Column>
        <Column>
          <MobileLink href={`mailto:${email}`}>{email}</MobileLink>
          <Span>{email}</Span>
        </Column>
        <Column>
          <MobileLink href={`tel:${phoneNumber}`} target="_blank">
            {phoneNumber}
          </MobileLink>
          <Span>{phoneNumber}</Span>
        </Column>
      </InformationContainer>
    </>
  )
}

UserDesigner.defaultProps = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
}

UserDesigner.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
}

export default UserDesigner
